export { default as CatalogoGrupoDeLocaisDeTrabalho } from './apresentacao/CatalogoGrupoDeLocaisDeTrabalho.vue'
export { usarCatalogoGrupoDeLocaisDeTrabalho } from './apresentacao/usar-catalogo-grupo-de-locais-de-trabalho'
export {
  CHAVE_OPERACOES_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO,
  usarOperacoesCatalogoGrupoDeLocaisDeTrabalho,
} from './apresentacao/catalogo-grupo-de-locais-de-trabalho.injecao'
export { DESCRITOR_CATALOGO_GRUPO_DE_LOCAIS_DE_TRABALHO } from './catalogo-grupo-de-locais-de-trabalho.tipos'
export type {
  FiltrosCatalogoGrupoDeLocaisDeTrabalho,
  OpcaoGrupoDeLocaisDeTrabalho,
  OperacoesCatalogoGrupoDeLocaisDeTrabalho,
  SelecaoCatalogoGrupoDeLocaisDeTrabalho,
} from './catalogo-grupo-de-locais-de-trabalho.tipos'
